import React, { Component } from 'react';
import { BrowserRouter as Router, Route} from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser,
} from "amazon-cognito-identity-js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './App.css';

import PageWrapper from "./components/PageWrapper";
import Home from "./components/Home";
import Admin from "./components/Admin";
import SalesDashboard from "./components/SalesDashboard";
import Movie from "./components/Movie";
import Login from "./components/Login";
import ScrollToTop from "./components/ScrollToTop";
import HubspotForm from "./components/HubspotForm";
import ContactPage from "./components/ContactPage";
import TutorialPage from "./components/TutorialPage";
import track from "./lib/tracking";
import movie_api from "./lib/movie_api";


class App extends Component {

  state = {
    movies: {},
    dynamodb: null,
    auth: "none",
    homepageShowAll: false,
    range: {from: moment(), to: moment().add('days',90)},
    redirect: "/"
  }

  componentDidMount(){
    try {
      window.Typekit.load({ async: true })
    }catch(e){
      console.log("typekit error",e)
    }
    
    this.continueSession();
  }

  setAuth = () => {

    if(this.state.auth === "auth"){
      return;
    }

    const token = window.location.href.split("&")[0].split("=")[1];
    window.AWS.config.region = "eu-west-2";
    window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'eu-west-2:5250ebdf-d8eb-4686-9572-8ad0e32cabfb',
      Logins: {
        'cognito-idp.eu-west-2.amazonaws.com/eu-west-2_LqKs2nyXj': token
      }
    });

    window.AWS.config.credentials.get( (err) => {
      if (err) {
        console.log(err);
      }else {
        const dynamodb = new window.AWS.DynamoDB();
        this.setState({dynamodb, auth: "auth"});
      }
    });

  }

  setRedirect = (redirect) => {
    this.setState({redirect});
  }

  setUnAuth = (force) => {
    return new Promise( (resolve, reject) => {
      if(this.state.auth !== "none" && !force){
        resolve();
      }else {
        window.AWS.config.region = "eu-west-2";
        window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'eu-west-2:5250ebdf-d8eb-4686-9572-8ad0e32cabfb',
        });
        window.localStorage.removeItem("gruvi-token");
        force && this.showNotification("sucess","Logged out");
        window.AWS.config.credentials.get( (err) => {
          const dynamodb = new window.AWS.DynamoDB();
          this.setState({dynamodb, auth: "unauth"});
          resolve();
        });

      }

    })
  }

  logout= () => {
    return this.setUnAuth(true);
  }

  setDatePicker = (range,datepickerModeSelected) => {
    track("search_header_date",{to: moment(range.to).format("DD-MM-YYYY"), from: moment(range.from).format("DD-MM-YYYY")})
    this.setState({range,datepickerModeSelected});
  }

  showNotification = (type, text) => {
    switch(type){
      case "sucess":
        toast.success(text, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        break;
      case "error":
        toast.error(text, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        break;
    }
  };

  continueSession = () => {
    const token = window.localStorage.getItem("gruvi-token");
    if(!token){
      this.setUnAuth(false);
      return ;
    }
    window.AWS.config.region = "eu-west-2";
    window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'eu-west-2:5250ebdf-d8eb-4686-9572-8ad0e32cabfb',
      Logins: {
        'cognito-idp.eu-west-2.amazonaws.com/eu-west-2_LqKs2nyXj': token
      }
    });

    window.AWS.config.credentials.get( (err) => {
      if (err) {
        this.showNotification("error","Token expired, please log in again");
        window.localStorage.removeItem("gruvi-token");
        this.logout()
      }else {
        this.showNotification("sucess","Logged in");
        const dynamodb = new window.AWS.DynamoDB();
        this.setState({dynamodb, auth: "auth",range: {from: moment(), to: moment().add('year',1)} });
      }
    });
  }

  login = (user, pass) => {
    const poolData = {
      UserPoolId : 'eu-west-2_LqKs2nyXj',
      ClientId : 'fir6dgri7afnkjdjnlcj24ej4'
    };
    const userPool = new CognitoUserPool(poolData);

    const authenticationData = {
        Username : user,
        Password : pass,
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);
    const userData = {
        Username : user,
        Pool : userPool
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
            const token = result.getIdToken().getJwtToken();
            window.AWS.config.region = "eu-west-2";
            window.AWS.config.credentials = new window.AWS.CognitoIdentityCredentials({
              IdentityPoolId: 'eu-west-2:5250ebdf-d8eb-4686-9572-8ad0e32cabfb',
              Logins: {
                'cognito-idp.eu-west-2.amazonaws.com/eu-west-2_LqKs2nyXj': token
              }
            });
            window.localStorage.setItem("gruvi-token",token);

            window.AWS.config.credentials.get( (err) => {
              if (err) {
                console.log(err);
                window.localStorage.removeItem("gruvi-token");
              }else {
                this.showNotification("sucess","Logged In");
                const dynamodb = new window.AWS.DynamoDB();
                this.setState({dynamodb, auth: "auth",range: {from: moment(), to: moment().add('year',1)}});
              }
            });
            
        },

      onFailure: (err) => {
        this.showNotification("error","Log In Failed\nplease retry");
        console.log(err);
      },

    });
  }

  deleteItem = (entry_id, msg, movie_id) => {
    const res = window.confirm(msg);
    if(!res){
      return;
    }
    movie_api.deleteItem(
      this.state.dynamodb,
      entry_id
    ).then( data => {
      this.showNotification("sucess","Item Archived");
      if(movie_id){
        this.setState( ({movies}) => {
          movies[movie_id].movie_entries = movies[movie_id].movie_entries.filter( o => o.entry_id !== entry_id );
          return ({movies});
        });
      }
    }).catch ( err => {
      this.logout();
      this.showNotification("error","Item update failed, please log in again");
    });
  }

  attributeMovieToEntry = (entry_id, movie_id, prev_movie_id) => {
    movie_api.attributeMovieToEntry(
      this.state.dynamodb,
      entry_id,
      movie_id
    ).then( data => {
      this.showNotification("sucess","Item Saved");
      if(prev_movie_id){
        this.setState( ({movies}) => {
          movies[prev_movie_id].movie_entries = movies[prev_movie_id].movie_entries.filter(o => o.entry_id !== entry_id);
          return ({movies});
        } )
      }
    }).catch ( err => {
      this.logout();
      this.showNotification("error","Item save failed, please log in again");
    });
  }

  updateMovie = (movie_id, original_title, english_title, poster, is_gruvi ) => {

    movie_api.updateMovie(
      this.state.dynamodb,
      movie_id,
      original_title,
      english_title,
      poster,
      is_gruvi
    ).then( data => {
      this.showNotification("sucess","Item Saved");
      this.setState( ({movies}) => {
        movies[movie_id] = {...movies[movie_id], ...data};
        return {movies};
      });
    }).catch( err => {
      this.logout();
      this.showNotification("error","Item save failed, please log in again");
    });

  }

  updateMovieEntry = (entry_id, movie_id, local_title, distributor, release_date, country, reviewed ) => {

    movie_api.updateMovieEntry(
      this.state.dynamodb,
      entry_id,
      movie_id,
      local_title,
      distributor,
      release_date,
      country,
      reviewed
    ).then( data => {
      this.showNotification("sucess","Item Saved");
      this.setState( ({movies}) => {
        movies[movie_id].movie_entries.forEach(e => {
          if(e.entry_id === entry_id){
            e = data;
          }
        });
        return {movies};
      });
    }).catch( err => {
      this.logout();
      this.showNotification("error","Item save failed, please log in again");
    });

  }

  createMovieEntry = ( movie_id, local_title, distributor, release_date, country ) => {

    movie_api.createMovieEntry(this.state.dynamodb, movie_id, local_title, distributor, release_date, country).then( data => {
      this.showNotification("sucess","Item Saved");
      this.setState( ({movies}) => {
        movies[movie_id].movie_entries.push(data);
        return {movies};
      });
    }).catch( err => {
      this.logout();
      this.showNotification("error","Item save failed, please log in again");
    });

  }

  createMovie = ( original_title, english_title, poster ) => {
    
    movie_api.createMovie(this.state.dynamodb, original_title, english_title, poster).then( data => {
      this.showNotification("sucess","Item Saved");
      this.setState( ({movies}) => ({movies: {...movies, [data.movie_id]: data}}) );
    }).catch( err => {
      this.logout();
      this.showNotification("error","Item save failed, please log in again");
    });

  }

  getAllDataForMovie = (movie_id) => {
    movie_api.getDataForMovie(this.state.dynamodb, movie_id).then( data => {
      this.setState( ({movies}) => ({movies: {...movies, [movie_id]: data }}) );
    });
  }

  getAdminItems = () => {
    movie_api.getAdminMoviesInfo(this.state.dynamodb).then( data => {
      this.setState(({movies}) => ({ movies: {...data, ...movies} }))
    });
  }  

  getItems = _.throttle(() => {
    movie_api.getMovieList(this.state.dynamodb, this.state.range).then( data => {
      this.setState(({movies}) => ({movies: data}));
    });
  },10000);

  getGruviItems = _.throttle(() => {
    movie_api.getGruviList(this.state.dynamodb, this.state.range).then( data => {
      this.setState(({movies}) => ({movies: data}));
    });
  },10000);


  render() {

    if(!this.state.dynamodb){
      return <div>loading</div>;
    }
    return <Router onUpdate={() => window.scrollTo(0, 0)} >
      <ScrollToTop>
        <div>
          <Route
            path="/"
            exact
            render={(props) =>(
              <PageWrapper
                page="home"
                authed={this.state.auth === "auth"}
                logout={this.logout} 
                setRedirect={this.setRedirect} 
              >
                <Home 
                  {...props}
                  data={this.state.movies}
                  homepageShowAllToggle={this.toggleHomepageMode}
                  getItems={this.getItems}
                  authed={this.state.auth === "auth"}
                />
              </PageWrapper>
            )}
          />
          <Route
            path="/admin"
            exact
            render={(props) =>(
              <Admin
                {...props}
                movies={this.state.movies}
                getItems={this.getItems}
                authed={this.state.auth === "auth"}
                updateMovieEntry={this.updateMovieEntry}
                updateMovie={this.updateMovie}
                homepageShowAllToggle={this.toggleHomepageMode}
                homepageShowAll={this.state.homepageShowAll}
                logout={this.logout}
                deleteItem={this.deleteItem}
                createMovieEntry={this.createMovieEntry} 
                createMovie={this.createMovie} 
                setRedirect={this.setRedirect}
                getInvalidEntries={ () => {} }
                getAdminItems={this.getAdminItems}
                attributeMovieToEntry= {this.attributeMovieToEntry}
              />
            )}
          />
          <Route
            path="/login"
            render={(props) =>(
              <Login
                {...props}
                authed={this.state.auth === "auth"}
                login={this.login}
                redirect={this.state.redirect}
              />
            )}
          />
          <Route
            path="/sales-dashboard"
            render={(props) =>(
              <SalesDashboard
                {...props}
                page="sales-dashboard"
                authed={this.state.auth === "auth"}
                setRedirect={this.setRedirect} 
                movies={this.state.movies}
                homepageShowAllToggle={this.toggleHomepageMode}
                homepageShowAll={this.state.homepageShowAll}
                logout={this.logout}
                getGruviItems={this.getGruviItems}
              />
            )}
          />
          <Route
            path="/release-form"
            render={(props) =>(
              <PageWrapper
                page="form"
                authed={this.state.auth === "auth"}
                logout={this.logout} 
                setRedirect={this.setRedirect} 
              >
                <HubspotForm
                  {...props}
                />
              </PageWrapper>
            )}
          />
          <Route
            path="/how-to"
            render={(props) =>(
              <TutorialPage
                {...props}
                authed={this.state.auth === "auth"}
                logout={this.logout}
                setRedirect={this.setRedirect}
              />
            )}
          />
          <Route
            path="/contact-us"
            render={(props) =>(
              <PageWrapper
                page="form"
                authed={this.state.auth === "auth"}
                logout={this.logout} 
                setRedirect={this.setRedirect} 
              >
                <ContactPage
                  {...props}
                />
              </PageWrapper>
            )}
          />
          <Route path="/movie/:movieTitle" render={(props) => {
            return (
              <PageWrapper
                authed={this.state.auth === "auth"}
                logout={this.logout} 
                setRedirect={this.setRedirect} 
              >
                <Movie
                  {...props}
                  authed={this.state.auth === "auth"}
                  logout={this.logout}
                  movies={this.state.movies}
                  getAdminItems={this.getAdminItems}
                  attributeMovieToEntry={this.attributeMovieToEntry}
                  homepageShowAllToggle={this.toggleHomepageMode}
                  homepageShowAll={this.state.homepageShowAll}
                  movieId={unescape(props.match.params.movieTitle)}
                  movie={this.state.movies[unescape(props.match.params.movieTitle)]}
                  updateMovieEntry={this.updateMovieEntry}
                  updateMovie={this.updateMovie}
                  getAllDataForMovie={this.getAllDataForMovie}
                  deleteItem={this.deleteItem}
                />
              </PageWrapper>  
            );
          }}/>
          <ToastContainer />
        </div>
      </ScrollToTop>

    </Router>
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js